import { find } from 'lodash'
import {
  Enum_Notification_Type,
  NotificationEntity,
  UsersPermissionsUserEntity
} from '../../../generated/graphql'

export const isNotificationRead = (
  notification: NotificationEntity,
  user: UsersPermissionsUserEntity
) => {
  const notificationAction = notification?.attributes?.action
  return notification?.attributes?.type === Enum_Notification_Type.MoreInfoRequested
    ? notification?.attributes?.read || false
    : find(
        notificationAction?.pushStatuses,
        (status) =>
          parseInt(status?.user?.id || '') ===
          parseInt((user as UsersPermissionsUserEntity)?.id || '')
      )
    ? true
    : false
}
